// extracted by mini-css-extract-plugin
export default {"invalid":"FormInput_invalid__1JoVa"};